import { Typography } from '@mui/material';
import type { Order } from '../../api/order';
import { getFullName } from '../utils/customer';
import OrderListCell from './OrderListCell';

interface OrderDetailsCellProps {
  order: Order;
}

const OrderDetailsCell = ({ order }: OrderDetailsCellProps) => {
  return (
    <OrderListCell>
      <Typography variant="body2" noWrap>
        {getFullName(order.customer)}
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        noWrap
        title={order.itemSummary}
        sx={{ display: 'block' }}
      >
        {order.itemSummary}
      </Typography>
    </OrderListCell>
  );
};

export default OrderDetailsCell;
